//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('consignmentLineSelect', {
//        templateUrl: 'views/components/views/consignmentLineSelect/consignmentLineSelect.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'modalService', 'translateService', 'consignmentLineSelectService', function ($stateParams, stateService, utilityService, modalService, translateService, consignmentLineSelectService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let consignmentKeyno = $stateParams.consignment_keyno;

//            let translations = {
//            	error: '',
//            	ok: ''
//            };

//            vm.model = {
//                setting: {},
//                itemsListConsignmentLines: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE CALLS

//            async function loadSetting() {
//                vm.model.setting = (await consignmentLineSelectService.getSetting({ consignment_keyno: consignmentKeyno }))[0];
//            }
            
//            async function loadConsignmentLines() {
//                if (utilityService.validateParmsValue(vm.model.setting.consignment_keyno) !== true) return;

//                return vm.model.itemsListConsignmentLines = await consignmentLineSelectService.listConsignmentLines({ consignment_keyno: vm.model.setting.consignment_keyno });
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region TOGGLE FUNCTIONS
            
//            vm.toggleChosen = function (item) {
//                item = item?.item ? item.item : item;
                
//                if (item.item_id === '0') return;
//                if (item.item_id === '-1') return;
                
//                if (item.item_is_selected === '0') {
//                    item.item_is_selected = '1';
//                } else if (item.item_is_selected === '1') {
//                    item.item_is_selected = '0';
//                }
//            };

//            // #endregion TOGGLE FUNCTIONS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                consignmentLineSelectService.saveObj({
//                    consignment_keyno: vm.model.setting.consignment_keyno,
//                    records: vm.model.itemsListConsignmentLines
//                }).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadSetting();
//                loadConsignmentLines();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
